<template>
  <div>
    <van-form @submit="onSubmitSocialAdd">
      <base-date v-if="!emp.disable" v-model="qc.begin_date" placeholder="请选择参保年月" label="参保年月" type="year-month" />
      <base-input v-model="qc.name.length > 5 ? '' : qc.name" :rules="rules.name" :disabled="emp.disable" placeholder="请输入员工姓名" readonly label="员工姓名" @focus="xa" />
      <base-input v-model="qc.id_card == 'undefined' ? '' : qc.id_card" :rules="rules.id_card" :disabled="emp.disable" placeholder="请输入身份证号码" label="身份证号码" />
      <van-radio-group v-model="radio" direction="horizontal" style="padding:0 4px;">
        <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">有无社保卡</p>
        <van-radio name="1" style="font-size: 13px;padding-left: 15px;">有</van-radio>
        <van-radio name="2" style="font-size: 13px;">无</van-radio>
      </van-radio-group>
      <base-input v-if="!emp.disable" v-model="qc.apply_salary" placeholder="请输入申报缴费工资" label="申报缴费工资" />
      <base-input v-if="who == 0 ? true:false" v-model="qc.pact_sign_salary"   placeholder="请输入劳动合同约定工资" label="合同约定工资" />
      <van-radio-group v-model="pact_type" direction="horizontal" style="">
        <p style="padding:0 14px; color: #646566;font-size: 14px;line-height:44px; height: 44px;">劳动合同类型</p>
        <van-radio name="1" style="font-size: 13px;">固定期限</van-radio>
        <van-radio name="2" style="font-size: 13px;">无固定期限</van-radio>
      </van-radio-group>
      <van-collapse v-model="qc.hold_nature" accordion>
        <van-collapse-item :title="'户口性质 :       ' + sf2" style="color:green;" name="1">
          <span v-for="(item, i) in sf" :key="i" style="cursor: pointer;padding-right: 20px; " @click="sfyz(item, i)">{{ item }}</span>
        </van-collapse-item>
      </van-collapse>
      <van-row style="color: #646566;font-size: 14px;line-height: 44px;">
        <van-col span="8" style="padding:0 14px; ">合同起始时间</van-col>
        <van-col span="7">
          <van-field
            v-model="qc.pact_begin_date"
            :rules="[{ required: true }]"
            readonly
            style="font-size: 12px; width:100px;padding-left: 2px; height:44px;border: 1px solid #F2F2F2;"
            @focus="(show2 = true), (ifx = 1)"
          />
        </van-col>
        <van-col span="1" style="text-align: center;height:44px;position: relative;left: -3px;">--</van-col>

        <van-col span="7">
          <van-field
            v-model="qc.pact_end_date"
            :rules="[{ required: true }]"
            readonly
            style="font-size: 12px;border: 1px solid #F2F2F2;  padding-left: 2px;width:100px; height:44px; "
            @focus="(show2 = true), (ifx = 2)"
          />
        </van-col>
      </van-row>

      <van-row type="flex" justify="center">
        <van-col span="24"><base-date v-model="qc.pact_sign_date" placeholder="请选择签署时间" label="合同签署时间" /></van-col>
      </van-row>

      <!-- <base-button :disabled="submitDisabled" native-type="submit" class="btn">提交</base-button> -->

      <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;padding-top: 20px;">
        <van-col span="12"><van-button type="info" class="btn" @click="cancel">取消</van-button></van-col>
        <van-col span="12"><base-button :disabled="submitDisabled" type="info" native-type="submit" class="btn">提交</base-button></van-col>
      </van-row>
    </van-form>
    <div>
      <van-popup v-model="show" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="show = false" @confirm="onConfirm" />
      </van-popup>
    </div>
    <div>
      <van-popup v-model="show2" :style="{ height: '50%' }" position="bottom" close-icon="close">
        <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" title="选择年月日" @cancel="show2 = false" @confirm="date(currentDate)" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Wxlist, ModifyX } from '@/api/Hremployee';
import { billadd } from '@/api/Hrbill';
import { dax } from '@/utils/date';
export default {
  name: 'SocialCommonAdd',
  props: {
    qc: {
      type: Object,
      default: function() {
        return {

        };
      }
    }
  },
  data() {
    return {
      who:sessionStorage.getItem('who'),
      show: false,
      sf: ['外埠城镇', '外埠农村', '本市城镇', '本市农村'],
      sf2: '',
      emp: {
        value: '',
        disabled: true
      },
      ifx: 0,
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show2: false,
      pact_type: '1',
      empList: [],
      emp_name: [],
      submitDisabled: false,
      rules: {
        name: [{ required: true, pattern: this.CONST.REG_EXP.PERSON_NAME, message: '姓名不能少于2个字符' }],
        id_card: [{ required: true, pattern: this.CONST.REG_EXP.ID_CARD, message: '输入的身份证号码不符合规范' }],
        mobile: [{ required: true, pattern: this.CONST.REG_EXP.MOBILE, message: '输入的手机号码不符合规范' }],
        hold_nature: [{ required: true }]
      },
      radio: '1'
    };
  },
  beforeRouteUpdate() {},
  beforeMount() {
    if (sessionStorage.getItem('who') === '0') {
      this.emp.disable = false;
      this.qc.name = '';
      this.emp.status = 2;
      this.qc.id_card = '';

      this.qc.apply_salary = '';
      this.query();
    } else {
      this.qc.emp_id = parseInt(sessionStorage.getItem('emp_id'));
      this.emp.disable = true;
    }
  },
  mounted() {},
  methods: {
    xa() {
      this.show = true;
      this.query();
    },
    sfyz(value, value1) {
      this.sf2 = value;
      this.qc.hold_nature = '0';
    },
    date(val) {
      dax(val, this.ifx);

      if (this.ifx === 1) {
        this.qc.pact_begin_date = sessionStorage.getItem('pact_date');
        this.show2 = false;
      }
      if (this.ifx === 2) {
        this.qc.pact_end_date = sessionStorage.getItem('end_date');
        this.show2 = false;
      }
    },
    cancel() {
      this.$emit('close');
    },
    onSearch() {
      this.query();
    },
    onConfirm(value, index) {
      if (this.empList[index].id_card === undefined) {
        this.emp.disabled = false;
        this.qc.id_card = '';
      } else {
        this.qc.id_card = this.empList[index].id_card;
        this.emp.disabled = true;
      }
      this.qc.name = this.emp_name[index].text;
      if (this.emp_name[index].disabled) {
        this.toast('该员工已有社保请重新选择！');
      } else {
        this.show = false;
      }
      if (this.empList[index].hold_nature !== undefined) {
        this.sf2 = this.empList[index].hold_nature;
      }
      this.qc.phone = this.empList[index].phone;

      if (this.empList[index].id !== undefined) {
        this.qc.emp_id = this.empList[index].id;
      }
      if (this.empList[index].client_id !== undefined) {
        this.qc.client_id = this.empList[index].client_id;
      }
    },
    onSubmitSocialAdd() {
      this.submitDisabled = true;
      this.$toast.loading({
        message: '提交中',
        forbidClick: true
      });
      const qc = this._.cloneDeep(this.qc);
      this.axios.post('/social/employee-modify', {
        client_id: parseInt(sessionStorage.getItem('client_id')),
        emp_id: qc.emp_id,
        hold_nature: this.sf2,
        pact_type: this.pact_type,
        pact_begin_date: qc.pact_begin_date,
        pact_end_date: qc.pact_end_date,
        pact_sign_date: qc.pact_sign_date,
        pact_sign_salary: qc.pact_sign_salary,
        token: sessionStorage.getItem('token')
      });
      billadd({
        client_id: parseInt(sessionStorage.getItem('client_id')),
        emp_id: qc.emp_id,
        name: qc.name,
        add_month: qc.begin_date ? qc.begin_date : null,
        type: '社保-普通增员',
        create_id: parseInt(sessionStorage.getItem('create_id')),
        status: this.emp.status ? this.emp.status : 1,
        apply_salary: parseInt(qc.apply_salary),
        id_card: qc.id_card,
        check_type: 1
      }).then(resp => {
        if (resp.success) {
          this.$toast.success('提交成功');
          this.$emit('close');
        } else {
          this.$toast.fail('提交失败');
        }
      });
    },
    query() {
      this.emp_name = [];
      this.empList = [];

      Wxlist({ client_id: parseInt(sessionStorage.getItem('client_id')), name: this.emp.value ? this.emp.value : null }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          this.empList.push({
            id: res.rows[i].id,
            id_card: res.rows[i].id_card,
            name: res.rows[i].name,
            phone: res.rows[i].phone,
            client_id: res.rows[i].client_id,
            hold_nature: res.rows[i].hold_nature
          });
          this.emp_name.push({ text: res.rows[i].name, disabled: true });
          if (res.rows[i].function_ids.indexOf('10') === -1 && res.rows[i].s_base === undefined) {
            this.emp_name[i].disabled = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.btn {
  display: block;
  margin: 0 auto;
  margin-top: 10px;
  width: 80%;
  height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/hr/social/common-add.vue